// extracted by mini-css-extract-plugin
module.exports = {"conclusions":"styles_conclusions__28Q3w","title":"styles_title__n4_iy","result":"styles_result__3fTrj","good":"styles_good__16iyy","bad":"styles_bad__2VtAs"};